import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Styles/ProjectSec.css";
import cmsImage from "../Assets/cms-image.jpg";
import amazonImage from "../Assets/amazon-image.jpg";
import cafeImage from "../Assets/cafe-image.jpg";
import { motion, useViewportScroll } from "framer-motion";

function ProjectSec() {
  const [showImage, setShowImage] = useState(cmsImage);
  const [imageLink, setImageLink] = useState(
    "http://cms-webapp.herokuapp.com/"
  );
  const [active, setActive] = useState("cms");

  // -- UX Animation --
  const vHeight = window.innerHeight;
  const { scrollY } = useViewportScroll();
  const [scrollValue, setScrollValue] = useState(0);

  useEffect(() => {
    scrollY.onChange((e) => {
      setScrollValue(scrollY.get());
    });
  }, [scrollY]);

  return (
    <Container fluid className="projectSec">
      <Row>
        <Col className=" text-center projectSec__title" xs={12}>
          <motion.h1
            animate={{
              opacity: scrollValue > vHeight / 3 ? 1 : 0,
              y: scrollValue > vHeight / 3 ? 0 : +50,
              transition: { type: "tween", duration: 0.5 },
            }}
            className="projectsec__font"
          >
            My Work Is My Passion
          </motion.h1>
        </Col>
      </Row>
      <Row className="projectSec__showcase">
        <motion.div
          animate={{
            x: scrollValue > vHeight / 2 ? 0 : -900,
            opacity: scrollValue > vHeight / 2 ? 1 : 0,
            transition: {
              type: "spring",
              stiffness: 80,
              damping: 13,
            },
          }}
          className="projectSec__projects"
        >
          <motion.h2
            className={active === "cms" ? "projectSec__active " : ""}
            onClick={() => {
              setShowImage(cmsImage);
              setImageLink("http://cms-webapp.herokuapp.com/");
              setActive("cms");
            }}
          >
            Custom CMS
          </motion.h2>
          <motion.h2
            className={active === "amazon" ? "projectSec__active " : ""}
            onClick={() => {
              setShowImage(amazonImage);
              setImageLink("https://clone-9f466.web.app/");
              setActive("amazon");
            }}
          >
            Amazon Clone
          </motion.h2>
          <motion.h2
            className={active === "cafe" ? "projectSec__active " : ""}
            onClick={() => {
              setShowImage(cafeImage);
              setImageLink("https://heyazhar.github.io/Cafe/");
              setActive("cafe");
            }}
          >
            Cravings Cafe
          </motion.h2>
        </motion.div>
        <a href={imageLink} target="_blank" rel="noopener noreferrer">
          <motion.img
            layout
            animate={{
              x: scrollValue > vHeight / 2 ? 0 : 900,
              opacity: scrollValue > vHeight / 2 ? 1 : 0,
              transition: {
                type: "spring",
                stiffness: 80,
                damping: 13,
              },
            }}
            className="projectSec__image"
            src={showImage}
            alt="project"
          />
        </a>
      </Row>
      <div className="projectSec__more">
        <motion.h5
          animate={{
            opacity: scrollValue > vHeight - 150 ? 1 : 0,
            transition: {
              delay: 0.5,
            },
          }}
        >
          selected projects
        </motion.h5>
      </div>
    </Container>
  );
}

export default ProjectSec;
